import React from "react";
import "./FooterStyles.scss";
const Footer = () => {
  return (
    <footer className='footer'>Designed and built by webspinner.eu</footer>
  );
};

export default Footer;
